<template>
  <div class="row d-lg-flex align-items-center mt-4" v-if="show">
    <div class="col-lg-12">
      <PoweredBy :url="url"/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import PoweredBy from "@/components/PoweredBy.vue";
import {bottomPoweredByUrls} from "@/consts";

export default {
  name: "BottomPoweredBy",
  components: {PoweredBy},
  computed: {
    ...mapGetters(['thirdLevelDomain']),
    ...mapGetters('appConfig', ['getAppConfigReady', 'getHidePoweredByLogo']),
    show() {
      return this.getAppConfigReady && !this.getHidePoweredByLogo && this.thirdLevelDomain in bottomPoweredByUrls
    },
    url() {
      return bottomPoweredByUrls[this.thirdLevelDomain]
    },
  },
}
</script>
